

const TRANSLATIONS_SK_SK = {
    "email_otp.back":"Naspäť",
    "email_otp.enter_email_text":"Nižšie zadajte emailovú adresu, na ktorú vám pošleme jedinečný kód.",
    "email_otp.send_verification_link":"Poslať verifikačný kód",
    "email_otp.resend_otp_with_timer":"Znova zaslať jednorazový kód o",
    "email_otp.text":"Na adresu [email] sme odoslali 6-ciferný verifikačný kód. Zadajte kód nižšie",
    "email_otp.verify":"Overiť",
    "reset_password.set_password":"Nastavte si heslo",
    "sign_in.or":"alebo",
    "sign_in.continue_with":"Alebo pokračujte cez",
    "sign_in.continue_with_email":"Alebo pokračujte pomocou e‑mailu",
    "sign_in.create_without_password":"Vytvorenie účtu bez hesla",
    "sign_in.create_with_otp":"Vytvorenie účtu pomocou jednorazového kódu",
    "sign_in.login_with_otp":"Prihlásenie pomocou jednorazového kódu",
    "sign_in.login_without_password":"Prihlásenie bez hesla",
    "sign_in.tooltip_text":"Na prístup k účtu vám e-mailom pošleme dočasný jedinečný verifikačný kód.",
    "sign_up.tooltip_text":"Na vytvorenie účtu vám e-mailom pošleme dočasný jedinečný verifikačný kód.",
    "sign_in.password_updated":"Vaše heslo bolo aktualizované.",
    "sign_up.create_an_account":"Vytvoriť účet",
    "email_otp.resend_otp":"Znova zaslať jednorazové heslo",
    "sign_up.email_address":"E-mailová adresa",
    "sign_up.password":"Heslo",
    "sign_in.create_account" : "Vytvorte si účet",
    "sign_in.title": "Prihlásenie",
    "sign_in.forgot_password" : "Zabudli ste heslo?",
    "reset_password.resend_email": "Znovu poslať e-mail",
    "reset_password.sent_title": "E-mail bol odoslaný!",
    "reset_password.rcvResetLink": "Zadajte vašu emailovou adresu nižšie a zašleme vám odkaz na resetovanie vášho hesla.",
    "reset_password.submit": "Pokračovať",
    "reset_password.back_to_login": "Späť na prihlásenie",
    "reset_password.create_new_password": "Vytvoriť nové heslo pre prihlásenie do Vášho účtu.",
    "forgot_password.emailSent": "Ak existuje účet pre adresu [], odošle sa e-mail s odkazom na obnovenie hesla. Ešte stále sa neobjavil? Nižšie požiadajte o nový e-mail.",
    "gdpr.continue": "Pokračovať",
    "validation.password_validation_heading": "Heslo musí obsahovať:",
    "validation.password_length_ui": "Najmenej 8 znakov",
    "validation.password_upper_case_ui": "Veľké písmeno",
    "validation.password_lower_case_ui": "Malé písmeno",
    "validation.password_number_ui": "Číslicu",
    "validation.password_symbol_ui": "Špeciálny znak",
    "verify_otp.customer_service_center_link": "s/zakaznicky-servis",
    "activate_user.verification_successful.message": "Blahoželáme! Váš účet bol aktivovaný.",
    "activate_user.already_verified.message" : "Vitajte späť! Váš účet už bol overený.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Skôr ako budete pokračovať, vyplňte všetky povinné polia.",
    "sign_in.invalid_email_error": "Zadajte e-mailovú adresu v správnom formáte, napr. meno@domena.sk",
    "sign_in.invalid_credentials_error": "Zadali ste neplatné užívateľské meno alebo heslo. Skúste to znova.",
    "sign_in.generic_error": "Vyskytla sa chyba. Skúste to znova.",
    "sign_in.account_unverified_error": "Váš účet ešte nie je aktivovaný. Ak chcete obnoviť prístup k svojmu účtu, skontrolujte, či ste dostali e-mail s aktivačným odkazom, alebo kliknite na „Zabudli ste heslo?“.",
    "sign_in.max_attempt_error": "Vyčerpali ste maximálny počet pokusov o prihlásenie. Skúste to o chvíľu znova.",
    "sign_in.social_signin_error": "Prihlásenie sa prostredníctvom sociálnych médií (Google/Facebook/Apple) zlyhalo. Skúste to znova alebo použite iný spôsob prihlásenia",
    "sign_in.social_signin_email_not_present_error": "Prihlásenie zlyhalo. Skúste to znova alebo použite inú možnosť prihlásenia.",
    "sign_in.guest_user_signin_error": "Zdá sa, že už máte účet s touto e-mailovou adresou. Kliknutím na „Zabudli ste heslo“ obnovíte prístup k svojmu účtu.",

    "sign_up.mandatory_field_error": "Skôr ako budete pokračovať, vyplňte všetky povinné polia.",
    "sign_up.invalid_email_error": "Zadajte platnú e-mailovú adresu, napr. meno@domena.sk",
    "sign_up.password_length_error": "Heslo musí mať aspoň 8 znakov.",
    "sign_up.email_already_exist_error": "Táto e-mailová adresa už existuje. Použite inú e-mailovú adresu.",
    "sign_up.generic_error": "Vyskytla sa chyba. Skúste to znova.",
    "sign_up.password_policy_error": "Heslo musí obsahovať: číslicu, špeciálny znak [!#$%&'*+-/=?^_`{|}~.@], veľké a malé písmená.",
    "sign_up.common_password_error": "Heslo sa nesmie zhodovať s vašou e-mailovou adresou",

    "forgot_password.mandatory_field_error": "Skôr ako budete pokračovať, vyplňte všetky povinné polia.",
    "forgot_password.invalid_email_error": "Zadajte e-mailovú adresu v správnom formáte, napr. meno@domena.sk",
    "forgot_password.generic_error": "Vyskytla sa chyba. Skúste to znova.",

    "reset_password.mandatory_field_error": "Skôr ako budete pokračovať, vyplňte všetky povinné polia.",
    "reset_password.password_history_error": "Heslo sa musí líšiť od posledných piatich hesiel.",
    "reset_password.password_length_error": "Heslo musí mať aspoň 8 znakov.",
    "reset_password.password_policy_error": "Heslo musí obsahovať: číslicu, špeciálny znak [!#$%&'*+-/=?^_`{|}~.@], veľké a malé písmená.",
    "reset_password.common_password_error": "Heslo sa nesmie zhodovať s vašou e-mailovou adresou",
    "reset_password.generic_error": "Vyskytla sa chyba. Skúste to znova.",

    "email_otp.email_required_error": "Ak chcete pokračovať, zadajte svoju e-mailovú adresu",
    "email_otp.invalid_email_error": "Zadajte platnú e-mailovú adresu, napr. meno@domena.sk",
    "email_otp.generic_error": "Vyskytla sa chyba. Skúste to o chvíľu znova",
    "email_otp.invalid_otp_error": "Zadané jednorazové heslo, resp. overovací kód je neplatný. Skúste to znova.",
    "email_otp.resend_otp_error": "Nebolo možné opätovne odoslať jednorazové heslo. Skúste to o chvíľu znova",
    "email_otp.verify_otp_error": "Vyskytla sa chyba. Pokúste sa zopakovať overenie prostredníctvom jednorazového hesla neskôr",
    "email_otp.verify_otp_limit_exceed_error": "Zadané jednorazové heslo je neplatné. Ak chcete získať nové jednorazové heslo, kliknite na „Odoslať znova jednorazové heslo“",
    "email_otp.max_attempt_reached_error": "Vyčerpali ste maximálny počet pokusov o prihlásenie. Skúste to o chvíľu znova.",
    "email_otp.brute_force_error_part_1": "Váš účet bol dočasne zablokovaný z dôvodu viacerých neúspešných pokusov o prihlásenie. Skúste to neskôr znova alebo ",
    "email_otp.brute_force_error_part_2": "sa obráťte na naše centrum pomoci",
    "email_otp.brute_force_error_part_3": ".",
    "form.gdprconsent": "Prihlásením potvrdzujete, že ste si prečítali a súhlasíte s našimi",
    "form.termsCondition": "zmluvnými podmienkami",

    //Page Titles
    "sign_in.page_title": "Prihlásenie | Pens.com",
    "sign_up.page_title": "Registrácia | Pens.com",
    "forgot-password.page_title": "Zabudnuté heslo | Pens.com",
    "reset-password.page_title": "Obnoviť heslo | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_SK_SK;